// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:22:29.743Z
// Property: Savona Grand (ID: 6767906449167533)
// Collections: 33 amenities, 11 floorplans (live), 19 photos, 36 POIs, 5 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6767906449167533",
  "property_external_id": "5680179",
  "property_zillow_url": "https://www.zillow.com/apartments/lake-worth-fl/savona-grand/5Xhy3z/",
  "property_apartments_url": "https://www.apartments.com/savona-grand-boynton-beach-fl/dh2kfzh/",
  "property_google_business_url": "https://www.google.com/maps/place/Savona+Grand+Apartments/@26.5692149,-80.1125809,2119m/data=!3m2!1e3!4b1!4m6!3m5!1s0x88d92742885bf4e3:0x8ba7825a9595b1b1!8m2!3d26.5692149!4d-80.1125809!16s%2Fg%2F11bytn0s64!5m1!1e2?entry=ttu&g_ep=EgoyMDI2MDYwMy4xIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "55519783467",
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "savona-grand",
  "property_name": "Savona Grand",
  "property_website_url": "https://www.liveatsavona.com/",
  "property_domain": "https://www.liveatsavona.com/",
  "property_address": "7132 Colony Club Dr",
  "property_full_address": "7132 Colony Club Dr, Lake Worth Beach, FL 33463",
  "property_address_1": "7132 Colony Club Dr",
  "property_address_2": null,
  "property_address_city": "Lake Worth Beach",
  "property_address_state": "FL",
  "property_address_zip_full": "33463-7839",
  "property_address_zip": "33463",
  "property_address_country": "US",
  "property_address_county": "Palm Beach County",
  "property_neighborhood_address": "Outer Boynton Beach",
  "property_address_latitude": "26.5689028",
  "property_address_longitude": "-80.11180019999999",
  "property_email": "savona@alapts.com",
  "property_phone": "(561) 641-3221",
  "property_call_tracking_phone": "561-464-2188",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Polished Palm Beach County apartment living, tucked beside scenic ponds.</strong> Explore spacious one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with full-size washers and dryers, generous storage, and select upgraded finishes—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Savona Grand in Lake Worth Beach.</p>",
  "property_long_description": "<p><strong>Polished apartment living with a relaxed Palm Beach County rhythm.</strong> At Savona Grand, you’re surrounded by scenic ponds, lush landscaping, and a controlled-access setting that feels tucked away while keeping Lake Worth Beach, Boynton Beach, and Greenacres within easy reach. Choose from spacious one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with everyday essentials like full-size washers and dryers, generous storage, gourmet kitchens with serving bars, and available balconies, lake views, stainless-steel appliances, designer countertops, vaulted ceilings, and hardwood-style plank flooring.</p><p>Beyond your front door, the community leans into indoor-outdoor living with a sparkling pool and sundeck, fitness center, basketball, tennis and pickleball courts, BBQ lounge, picnic grilling areas, car care station, and dog park. From this Outer Boynton Beach location, you’re close to Boynton Beach Mall, Winston Trails Golf Club, John Prince Park, Lake Worth Beach’s artsy downtown, the Lake Worth Playhouse, Snook Islands, and the Municipal Beach and Pier—making it easy to fill your week with errands, dining, culture, and coastal escapes.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8d82-d041-777f-a411-5b1aaac3fd07.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment buildings surrounding a serene lake with a walking path.",
    "public_id": "019f8d82-d041-777f-a411-5b1aaac3fd07",
    "storage_key": "property/6767906449167533/019f8d82-d041-777f-a411-5b1aaac3fd07.webp",
    "width": 2048,
    "height": 1367
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "214",
  "property_year_built": "2003",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.13084112149532",
  "property_admin_fee": "350",
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit: $1000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://9324198.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://savonagrandfl.loftliving.com/login",
  "property_apply_now_url": "https://9324198.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8682-4510-746f-a97d-845d1289a5dd.webp",
  "property_primary_logo_media": {
    "alt_text": "Savona Grand logo",
    "public_id": "019f8682-4510-746f-a97d-845d1289a5dd",
    "storage_key": "property/6767906449167533/019f8682-4510-746f-a97d-845d1289a5dd.webp",
    "width": 1411,
    "height": 453
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8682-44d4-722e-b635-36dc6f088f6e.webp",
  "property_secondary_logo_media": {
    "alt_text": "SG logo",
    "public_id": "019f8682-44d4-722e-b635-36dc6f088f6e",
    "storage_key": "property/6767906449167533/019f8682-44d4-722e-b635-36dc6f088f6e.webp",
    "width": 666,
    "height": 452
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8682-4560-76cc-827a-d2611623815b.webp",
  "property_icon_media": {
    "alt_text": "SG logo with gold accent on a dark blue geometric background",
    "public_id": "019f8682-4560-76cc-827a-d2611623815b",
    "storage_key": "property/6767906449167533/019f8682-4560-76cc-827a-d2611623815b.webp",
    "width": 1400,
    "height": 1399
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8682-44d4-722e-b635-36dc6f088f6e.webp",
  "property_fav_icon_media": {
    "alt_text": "SG logo",
    "public_id": "019f8682-44d4-722e-b635-36dc6f088f6e",
    "storage_key": "property/6767906449167533/019f8682-44d4-722e-b635-36dc6f088f6e.webp",
    "width": 666,
    "height": 452
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8685-9126-762e-a91c-3cfd79e0e564.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Savona Grand logo",
    "public_id": "019f8685-9126-762e-a91c-3cfd79e0e564",
    "storage_key": "property/6767906449167533/019f8685-9126-762e-a91c-3cfd79e0e564.webp",
    "width": 1411,
    "height": 452
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8685-69c9-74eb-ab5d-af7a24b14f61.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Savona Grand logo",
    "public_id": "019f8685-69c9-74eb-ab5d-af7a24b14f61",
    "storage_key": "property/6767906449167533/019f8685-69c9-74eb-ab5d-af7a24b14f61.webp",
    "width": 1411,
    "height": 452
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#3E5A6A",
  "property_secondary_color": "#D9AD5B",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#15201C",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "824 - 1489",
  "property_sqft_min": "824",
  "property_sqft_max": "1489",
  "property_price_range": "1965 - 3060",
  "property_price_min": "2137",
  "property_price_max": "3060",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=100092206269989",
  "property_instagram_url": "https://www.instagram.com/savonagrand/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ4_RbiEIn2YgRsbGVlVqCp4s",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/savona-grand-by-zrs-management-lake-worth",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Savona Grand",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "<p><strong>Amenities with momentum.</strong> At Savona Grand, days flow from the fitness center to the poolside sundeck, sport courts, or an outdoor dinner at the BBQ lounge and grilling areas. Scenic ponds, lush landscaping, controlled access, and a car care station round out the convenience, while select apartments add stainless-steel appliances, designer countertops, plank flooring, balconies, vaulted ceilings, and lake views.</p>",
  "property_home_floorplans_blurb": "<p><strong>One-, two-, and three-bedroom layouts with room to choose.</strong> Savona Grand floor plans pair bright living areas with everyday essentials like gourmet kitchens with serving bars, spacious closets, and full-size washers and dryers. Select homes elevate the details with hardwood-style plank flooring, stainless-steel appliances, designer countertops, vaulted ceilings, balconies, and lake views.</p>",
  "property_home_gallery_blurb": "<p><strong>See Savona Grand in its best light.</strong> Preview bright interiors with plank-style flooring, stainless-steel appliances, gourmet kitchens with serving bars, and available balconies overlooking landscaped ponds. Then picture the everyday backdrop: a pool and sundeck, fitness center, sport courts, BBQ lounge, picnic grills, and dog park, all with an easygoing Lake Worth Beach feel.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Everyday ease, coastal escapes.</strong> Savona Grand puts you near Jog and Lantana with quick access to Publix at Lantana Plaza, Lake Worth Road dining, and routes to Boynton Beach, Wellington, Greenacres, and the coast. Head east for dockside restaurants at Boynton Harbor Marina or Atlantic views at Ocean Inlet Park, then come home to scenic ponds, landscaped paths, and easygoing on-site amenities.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out in resident reviews.</strong> Savona Grand earns praise for responsive service, friendly maintenance, and requests handled quickly—often done right the first time. Residents also highlight Florence and the office team for clear communication, smoother move-ins, cleaner shared spaces, and a calmer everyday atmosphere, all adding up to a community that feels consistently cared for.</p>",
  "property_neighborhood_blurb": "<p><strong>Your map opens in every direction.</strong> From Savona Grand’s Outer Boynton Beach setting near Jog and Lantana, daily stops stay simple—Publix at Lantana Plaza, restaurants along Lake Worth Road and Military Trail, and easy routes toward Wellington, Greenacres, Boynton Beach, and coastal Lake Worth Beach. When the day calls for water, head east to Boynton Harbor Marina for dockside dining at Banana Boat or Two Georges, or keep going to Ocean Inlet Park for sand, jetties, and Atlantic views.</p><p>Closer to home, scenic ponds and landscaped paths keep the setting calm, while <a href=\"/amenities\">on-site amenities</a> make it easy to unwind before your next outing. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how connected this Palm Beach County location feels.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep every day moving.</strong> At Savona Grand, your routine can shift easily from a workout in the fitness center to a swim on the sundeck, a match on the tennis, basketball, or pickleball courts, or dinner outside at the BBQ lounge and grilling areas. Scenic ponds, lush landscaping, controlled access, and a convenient car care station add practical ease to the community setting.</p><p>Inside, your apartment is designed for the details that matter: full-size washers and dryers, spacious closets, gourmet kitchens with serving bars, and available upgrades like stainless-steel appliances, designer countertops, hardwood-style plank flooring, balconies, vaulted ceilings, and lake views. Explore the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at Savona Grand.</strong> Apply online for polished Lake Worth Beach apartment living with spacious one-, two-, and three-bedroom layouts, full-size washers and dryers, generous storage, and a relaxed setting surrounded by ponds and lush landscaping.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong><br>Contact the Savona Grand leasing team for details on spacious floor plans, relaxed Palm Beach County living, or directions to our tucked-away Lake Worth Beach community near Boynton Beach and Greenacres.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Savona Grand?</strong> Start here for helpful answers about the community, leasing, apartment features, amenities, and everyday living in our controlled-access Lake Worth Beach setting. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Savona Grand offers one-, two-, and three-bedroom apartment homes in Lake Worth Beach, giving you room to choose the right balance of open living space, storage, and everyday convenience. As you browse the floor plan cards, compare layouts with bright living areas, fully equipped gourmet kitchens with serving bars, spacious closets, and full-size washers and dryers that keep daily routines simple.</p><p>Select homes add the polished details that make a space feel even more inviting, from hardwood-style plank flooring and stainless-steel appliances to designer countertops, vaulted ceilings, available balconies, and lake views. Once you’ve found a favorite, explore the <a href=\"/gallery\">photo gallery</a>, review more <a href=\"/amenities\">features and finishes</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how each floor plan lives in person.</p>",
  "property_gallery_blurb": "<p><strong>Start with the views, then follow the light.</strong> In the Savona Grand photo gallery, you can picture mornings in bright living spaces, dinner prep at a gourmet kitchen with a serving bar, and fresh air from an available balcony with landscaped ponds nearby. The images move naturally from available apartment details—plank-style flooring, stainless-steel appliances, rainmaker shower heads—to the outdoor scenes that give the community its easygoing Lake Worth Beach feel. Browse the pool and sundeck, fitness center, sport courts, BBQ lounge, picnic grills, and dog park, then compare the spaces with <a href=\"/floor-plans\">available floor plans</a> or take a closer look through <a href=\"/virtual-tours\">virtual tours</a>. When a photo feels like the right fit, <a href=\"/schedule-a-tour\">schedule a tour</a> and see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>See what surrounds Savona Grand.</strong> Use the interactive map to explore available apartments and the Outer Boynton Beach area—from everyday stops to dining, culture, parks, and coastal escapes within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room to roam.</strong> At Savona Grand, cats and dogs can feel right at home with spacious apartment layouts, full-size washers and dryers for post-park cleanups, and available balconies that bring in fresh air. Outside, scenic ponds, lush landscaping, and an on-site <a href=\"/amenities\">dog park</a> give daily routines more variety, from quick walks to extra playtime close to home. Lake Worth Beach also keeps pet errands and outings convenient, with local supply shops and county dog parks within easy reach. Review the pet policy details below, then <a href=\"/contact-us\">contact the leasing team</a> with questions about approvals, fees, and next steps.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Savona Grand lifestyle.</strong> Invite a friend to discover polished Lake Worth Beach apartment living with scenic ponds, lush landscaping, spacious floor plans, and easygoing indoor-outdoor spaces made for relaxing, gathering, and enjoying the Palm Beach County rhythm.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Savona Grand.</strong> Keep everyday apartment living running smoothly in your tucked-away Lake Worth Beach community. Log in to pay rent, submit maintenance requests, and manage account details—so you can get back to enjoying the relaxed Palm Beach County rhythm at home.</p>",
  "property_reviews_blurb": "<p><strong>Resident voices say it best.</strong> As you read through Savona Grand reviews, you’ll see a clear pattern: residents appreciate a team that responds, follows through, and takes pride in the community. Maintenance is frequently praised for being friendly, helpful, and quick to resolve requests—often “done right the first time.”</p><p>You’ll also notice repeated shout-outs for Florence and the office team, with residents pointing to clear communication, smooth move-ins, cleaner shared spaces, and a more peaceful day-to-day atmosphere. From attentive service to well-kept surroundings and beautiful apartment homes, these reviews offer a real look at what it feels like when a community is cared for with consistency.</p>",
  "property_created_at": "1781036375674",
  "property_scheduletour_blurb": "<p><strong>See Savona Grand in person.</strong> Tour polished one-, two-, and three-bedroom apartments surrounded by scenic ponds, lush landscaping, and relaxed Palm Beach County energy. Explore spacious layouts, thoughtful finishes, and indoor-outdoor community spaces—then picture your routine here. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The Savona Grand leasing team will be in touch soon to help with your next step. In the meantime, picture polished apartment living surrounded by scenic ponds, lush landscaping, spacious floor plans, and relaxed indoor-outdoor amenities in easy reach of Lake Worth Beach, Boynton Beach, and Greenacres.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the apartment before you arrive.</strong> Savona Grand’s virtual tours let you step inside the available apartment walkthroughs for Unit 201 and Unit 208, moving room to room at your own pace from wherever you are. Use the tours to compare the feel of each layout: how the living area connects to the kitchen, where storage fits into daily routines, and how natural light changes the space.</p><p>As you explore, look for the details that help a home feel polished and practical, from full-size washers and dryers to gourmet kitchens with serving bars and available upgraded finishes. After the walkthroughs, browse <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Savona Grand in Lake Worth Beach in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Savona Grand",
  "property_seo_title_home": "Savona Grand |  Apartments in Lake Worth Beach, FL",
  "property_seo_description_home": "Experience resort-style living at Savona Grand in Lake Worth Beach! Choose from spacious one, two, or three-bedroom apartments with unbeatable amenities.",
  "property_seo_title_floorplans": "Floor Plans | Lake Worth Beach, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal haven at Savona Grand in Lake Worth Beach, FL. Choose from stylish one, two, or three-bedroom floor plans tailored for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Lake Worth Beach, FL Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Savona Grand in Lake Worth Beach! Enjoy luxurious amenities, from a sparkling pool to scenic ponds, perfect for relaxing and entertaining.",
  "property_seo_title_gallery": "Gallery | Apartments in Lake Worth Beach, FL",
  "property_seo_description_gallery": "Picture life at Savona Grand in Lake Worth Beach! Enjoy luxury living with amenities like a pool, dog park, and stunning lake views. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Savona Grand Apartments",
  "property_seo_description_virtualtours": "Step into luxury at Savona Grand, Lake Worth Beach. Experience spacious one, two, and three-bedroom apartments. Take a virtual tour and find your perfect home!",
  "property_seo_title_interactivemap": "Interactive Map | Savona Grand Apartments",
  "property_seo_description_interactivemap": "Experience luxury living at Savona Grand in Lake Worth Beach, FL. Unleash your lifestyle with top-notch amenities, spacious floor plans, and serene lake views!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Lake Worth Beach, FL",
  "property_seo_description_neighborhood": "Uncover the charm of Lake Worth Beach near Savona Grand. From local favorites to hidden gems, dive into what makes our neighborhood truly inviting!",
  "property_seo_title_contact": "Contact Us | Savona Grand",
  "property_seo_description_contact": "Contact Savona Grand in Lake Worth Beach, FL! Our leasing team is here to answer your questions about our spacious one to three-bedroom plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Lake Worth Beach, FL",
  "property_seo_description_faqs": "Uncover answers to your queries about Savona Grand, a gated Lake Worth Beach gem. Dive into amenities, floor plans, and more on our FAQs page!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lake Worth Beach, FL",
  "property_seo_description_reviews": "Join the vibrant community at Savona Grand in Lake Worth Beach! Check out resident reviews and see why our homes, amenities, and lifestyle shine!",
  "property_seo_title_applynow": "Apply Now | Apartments in Lake Worth Beach, FL",
  "property_seo_description_applynow": "Experience luxury living at Savona Grand! Enjoy stunning lake views, a sparkling pool, and a state-of-the-art fitness center. Your perfect home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Savona Grand",
  "property_seo_description_residentaccess": "Access Savona Grand's resident portal for easy rent payments, maintenance requests, and more. Your convenience awaits in beautiful Lake Worth Beach, FL!",
  "property_seo_title_referafriend": "Refer A Friend | Savona Grand",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Savona Grand in Lake Worth Beach and enjoy exclusive perks together in your vibrant coastal community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Savona Grand",
  "property_seo_description_scheduletour": "Experience the charm of Savona Grand in Lake Worth Beach, FL. Schedule your tour today to find your perfect home by the sea!",
  "property_seo_title_privacy": "Privacy Policy | Savona Grand",
  "property_seo_description_privacy": "At Savona Grand in Lake Worth Beach, FL, your privacy matters. Dive into our policy to understand how we protect your data while you enjoy serene living.",
  "property_seo_title_accessibility": "Website Accessibility | Savona Grand",
  "property_seo_description_accessibility": "At Savona Grand in Lake Worth Beach, we're committed to digital inclusion. Our accessibility features ensure everyone feels at home. Learn how we support you!",
  "property_seo_title_sitemap": "Sitemap | Savona Grand",
  "property_seo_description_sitemap": "Uncover Savona Grand’s vibrant community in Lake Worth Beach, FL! Navigate our sitemap to find your dream apartment and explore exceptional living today.",
  "property_seo_title_thankyou": "Thank You | Savona Grand",
  "property_seo_description_thankyou": "Thank you for reaching out to Savona Grand in Lake Worth Beach! Our team will connect soon to help you find your perfect new home by the sea.",
  "property_seo_title_pets": "Pet Policy | Apartments in Lake Worth Beach, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234321448",
  "amenities": [
    {
      "id": "custom_26e2d2ab-58b4-4e1d-9f82-073415cc1e77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliance Package*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a4a5407-03cf-49ec-9973-399adff3a8c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In Home Full-Size Washer & Dryer",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa850641-d711-4847-9576-ad350bade153",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Oversized Closets*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da1d5e1f-8fd4-4c1b-930c-43e0810aada4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz Countertops*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b263641e-b04b-4b66-a1fa-7111f07ad793",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000002568",
      "title": "Smart Card",
      "amount": "0.0000",
      "description": "Smart Home Features**",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4afb5e38-22a1-41a6-be40-f12a886036a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000596",
      "title": "Alarms",
      "amount": "0.0000",
      "description": "Built-In Home Security System*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38171973-bfce-4203-a351-14fe53b00c79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000654",
      "title": "Lake Views",
      "amount": "0.0000",
      "description": "Scenic Lake Views*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17ed76ec-36ad-43dd-9619-776688b29cf8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Spa-Inspired Bathrooms with Rainfall Showerhead*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e70f13d0-028f-4a61-9107-51a613d9bb0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patio or Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_16d2dc37-a341-459d-bd14-f706bd52cfe1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000002654",
      "title": "Vinyl Plank Throughout",
      "amount": "0.0000",
      "description": "Wood-Inspired Plank Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_adc57d49-4fb5-48b6-88ad-51aa4a5649ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Soaring Vaulted Ceilings*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e139265-1150-46d8-8c48-e50350234321",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Chef-Inspired Kitchen with Serving Bar",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_11384152-9997-4690-af1a-b83a0d9e9370",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3335fd6-51a0-46d8-a9ae-366b75c46f79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000593",
      "title": "*Coming Soon",
      "amount": "0.0000",
      "description": "**Coming Soon",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae7d386b-901b-46fe-b3a4-328b979d6273",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Swimming Pool with Expansive Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7df34159-c7a9-4c39-98c3-77c3ddb36429",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Off-Leash Dog Park",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a90e220b-915f-4899-9b6c-91029db6cad1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "EV Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5281d71c-9497-4a5b-8b93-00fdd3549c62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1bfeac35-b46e-42ff-9ff6-ef864b287d13",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000708",
      "title": "Wifi",
      "amount": "0.0000",
      "description": "Work-From-Home Lounge with Wi-Fi",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b9fb281-d090-4a78-830f-874f70701036",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Entertainment Lounge with Grilling Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe5557f7-faff-419d-ad3a-2a773232fc4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000002449",
      "title": "Fire Pit and BBQ Grill Station",
      "amount": "0.0000",
      "description": "Picnic Grove with Grilling Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e70bf111-fd44-4a81-9961-6a91b39f363d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000649",
      "title": "Internet Café",
      "amount": "0.0000",
      "description": "High-Speed Internet Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cac53f43-2a56-411d-8192-896447aad65c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000653",
      "title": "Lake",
      "amount": "0.0000",
      "description": "Scenic Ponds & Green Spaces",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e5e256a2-785d-4c9a-8391-fe157bff21b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Smart Package Locker System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2dc6c79c-51d3-42ee-89c6-e0ee3ee19bdb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5a27a20-8230-4b4d-b135-641b9e7a3a5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000668",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Community Playground",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1a36558-a85e-4b4c-ba4d-aea74a246d9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000685",
      "title": "Sports Court",
      "amount": "0.0000",
      "description": "Basketball, Tennis & Pickleball Courts",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_79213f3b-b410-4fb9-b816-77dcfbe1d35f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000002647",
      "title": "Additional Storage Units",
      "amount": "0.0000",
      "description": "Additional Storage Space",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05663b9f-dfd6-45b4-a036-dc6d4c233c8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "On-Site Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c72832b-6e42-4022-aa39-f555449f1561",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f74d509e-918f-439b-8684-1802c94b2c3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6e7e3bf7-c4fc-463e-98e3-3b2c60e74ea9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Concierge Cleaning Services Available by Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_16ad0763-02be-4cbd-acfb-90759c8e5f05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8f6697e8-5075-4b2e-8554-df09e4080dea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-7440-72ef-8005-0a347e241a5e.webp",
      "image_media": {
        "alt_text": "Savona Grand monument sign with landscaping",
        "public_id": "019fcd42-7440-72ef-8005-0a347e241a5e",
        "storage_key": "property/6767906449167533/019fcd42-7440-72ef-8005-0a347e241a5e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Savona Grand at Barton Beach, a premier apartment community.",
      "link": "",
      "alt_text": "Savona Grand monument sign with landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c3a4194-8dc7-4036-b683-d2727a7b067d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-679c-747d-91b4-04a536ddad80.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court and tennis courts surrounded by trees.",
        "public_id": "019fcd42-679c-747d-91b4-04a536ddad80",
        "storage_key": "property/6767906449167533/019fcd42-679c-747d-91b4-04a536ddad80.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on the full court or play tennis on the blue courts. Outdoor recreation for residents.",
      "link": "",
      "alt_text": "Outdoor basketball court and tennis courts surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce2a6079-d004-4e81-a0c4-f42ab88c4814",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-5bdd-761a-9563-c26268ed223e.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with sofas and chairs, a large TV, and decorative shelves.",
        "public_id": "019fcd42-5bdd-761a-9563-c26268ed223e",
        "storage_key": "property/6767906449167533/019fcd42-5bdd-761a-9563-c26268ed223e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, featuring plush seating, a large entertainment center, and elegant decor. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Comfortable seating area with sofas and chairs, a large TV, and decorative shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b7bc302-d80a-4314-994e-3e965381c732",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-53dc-762c-ba08-a864a7bb2260.webp",
      "image_media": {
        "alt_text": "Lobby area with comfortable seating and a coffee table.",
        "public_id": "019fcd42-53dc-762c-ba08-a864a7bb2260",
        "storage_key": "property/6767906449167533/019fcd42-53dc-762c-ba08-a864a7bb2260.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed lobby, featuring plush seating and a stylish coffee table, perfect for gathering with friends or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Lobby area with comfortable seating and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9aebc77e-bb78-460e-9414-2c8dd2d65131",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-5dfa-7660-9d90-d3947601ff51.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, chrome faucet, and a glass-enclosed shower with white tile.",
        "public_id": "019fcd42-5dfa-7660-9d90-d3947601ff51",
        "storage_key": "property/6767906449167533/019fcd42-5dfa-7660-9d90-d3947601ff51.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Clean and bright bathroom featuring a white vanity with ample storage, a sleek sink, and a spacious glass-enclosed shower with classic white tile.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, sink, chrome faucet, and a glass-enclosed shower with white tile.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b53fc94-3ca8-44cb-94d3-439ba001674b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-5210-7719-984d-71c8fe96ff6d.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with two grills, stone counter, and umbrella-shaded table.",
        "public_id": "019fcd42-5210-7719-984d-71c8fe96ff6d",
        "storage_key": "property/6767906449167533/019fcd42-5210-7719-984d-71c8fe96ff6d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy cooking and dining al fresco with our built-in outdoor kitchen, featuring two premium grills and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor kitchen area with two grills, stone counter, and umbrella-shaded table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_78309e7c-0e7c-4233-9c0a-2ecaea620199",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-4b21-7408-8714-0b4f271f333e.webp",
      "image_media": {
        "alt_text": "Blue tennis courts with nets and palm trees in the background.",
        "public_id": "019fcd42-4b21-7408-8714-0b4f271f333e",
        "storage_key": "property/6767906449167533/019fcd42-4b21-7408-8714-0b4f271f333e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our vibrant blue tennis courts, surrounded by lush greenery and palm trees.",
      "link": "",
      "alt_text": "Blue tennis courts with nets and palm trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3848c02f-6f2e-47b0-85f0-71ddfad9c886",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-4bf8-7394-83fe-e29a4824fa62.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019fcd42-4bf8-7394-83fe-e29a4824fa62",
        "storage_key": "property/6767906449167533/019fcd42-4bf8-7394-83fe-e29a4824fa62.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0349512-b4fd-4fad-adcb-88fd2ba14ab1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-2a7a-730e-a883-e00d32032d7d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light cream cabinetry.",
        "public_id": "019fcd42-2a7a-730e-a883-e00d32032d7d",
        "storage_key": "property/6767906449167533/019fcd42-2a7a-730e-a883-e00d32032d7d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring a full-size range, microwave, dishwasher, and ample cabinet space for comfortable living.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and light cream cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c767d5a-2264-4f1d-ad94-ee21f36c7239",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-1bb2-71be-8301-a42109e0b010.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and driveways.",
        "public_id": "019fcd42-1bb2-71be-8301-a42109e0b010",
        "storage_key": "property/6767906449167533/019fcd42-1bb2-71be-8301-a42109e0b010.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring individual garages and well-kept landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and driveways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dec23f6f-7462-4101-a4af-218e28b16519",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd41-feaa-777c-96de-0f1a4a346366.webp",
      "image_media": {
        "alt_text": "Apartment buildings overlooking a serene lake with a fountain.",
        "public_id": "019fcd41-feaa-777c-96de-0f1a4a346366",
        "storage_key": "property/6767906449167533/019fcd41-feaa-777c-96de-0f1a4a346366.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience peaceful living with beautiful lake views and lush green surroundings at our apartment community.",
      "link": "",
      "alt_text": "Apartment buildings overlooking a serene lake with a fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ef7490f-728a-478f-a3a1-c201677a5813",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-21e0-765b-95b9-5ba77bd5eb4c.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, quartz countertops, stainless steel refrigerator, stove, microwave, and dishwasher.",
        "public_id": "019fcd42-21e0-765b-95b9-5ba77bd5eb4c",
        "storage_key": "property/6767906449167533/019fcd42-21e0-765b-95b9-5ba77bd5eb4c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinets, durable quartz countertops, and modern stainless steel appliances including a refrigerator, stove, microwave, and dishwasher.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, quartz countertops, stainless steel refrigerator, stove, microwave, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9898260-0078-429d-b5db-e1ccece30133",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-2061-748a-9232-6a25af59702f.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a lake and fountain in front.",
        "public_id": "019fcd42-2061-748a-9232-6a25af59702f",
        "storage_key": "property/6767906449167533/019fcd42-2061-748a-9232-6a25af59702f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with a serene lake and fountain, surrounded by lush greenery and palm trees. Enjoy the picturesque community scenery.",
      "link": "",
      "alt_text": "Apartment buildings with a lake and fountain in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25eb46bc-aafe-44dd-9b67-2fad3db62efb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-1141-73aa-82db-63a8522eb092.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, and free weights.",
        "public_id": "019fcd42-1141-73aa-82db-63a8522eb092",
        "storage_key": "property/6767906449167533/019fcd42-1141-73aa-82db-63a8522eb092.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Fully equipped fitness center with cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5d67a69-d94f-43f5-a5bf-5585dc3315c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd42-0da8-712c-ba06-c9da66ca2799.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet with shelves above.",
        "public_id": "019fcd42-0da8-712c-ba06-c9da66ca2799",
        "storage_key": "property/6767906449167533/019fcd42-0da8-712c-ba06-c9da66ca2799.webp",
        "width": 1110,
        "height": 740
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with convenient shelving for laundry supplies.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry closet with shelves above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9e31ee7a-073d-426f-93a3-d7ca43e95b31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd41-f3f0-7732-b81b-73fa0f20a9c9.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and a view of the balcony.",
        "public_id": "019fcd41-f3f0-7732-b81b-73fa0f20a9c9",
        "storage_key": "property/6767906449167533/019fcd41-f3f0-7732-b81b-73fa0f20a9c9.webp",
        "width": 930,
        "height": 621
      },
      "title": "Apartment",
      "description": "Spacious living area with modern furnishings, a large TV, and balcony access, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, TV, and a view of the balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b95fb861-1fff-432e-a00b-102fbfb1a5a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd41-f5a1-7208-ad7d-c731fc4867ba.webp",
      "image_media": {
        "alt_text": "Living room and dining area of an apartment.",
        "public_id": "019fcd41-f5a1-7208-ad7d-c731fc4867ba",
        "storage_key": "property/6767906449167533/019fcd41-f5a1-7208-ad7d-c731fc4867ba.webp",
        "width": 1110,
        "height": 741
      },
      "title": "Apartment",
      "description": "Modern living and dining area with comfortable seating, a stylish shelving unit, and a view into the kitchen. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8acb9869-5a3b-4753-957a-be6baa8bf31b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd41-f3e8-7189-a716-9816fac6d188.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, bedside table, ceiling fan, and window.",
        "public_id": "019fcd41-f3e8-7189-a716-9816fac6d188",
        "storage_key": "property/6767906449167533/019fcd41-f3e8-7189-a716-9816fac6d188.webp",
        "width": 1110,
        "height": 741
      },
      "title": "Apartment",
      "description": "Relax in this spacious and inviting bedroom, featuring a comfortable queen-size bed, modern bedside table, and a ceiling fan for ultimate comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, bedside table, ceiling fan, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b6ebc04-f1a2-43d9-8b61-4d8b840374b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019fcd4a-c249-702c-ae7c-892e17c5cbd4.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and tub/shower combo",
        "public_id": "019fcd4a-c249-702c-ae7c-892e17c5cbd4",
        "storage_key": "property/6767906449167533/019fcd4a-c249-702c-ae7c-892e17c5cbd4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a vanity with ample counter space, a toilet, and a tub/shower combination with sliding glass doors.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and tub/shower combo",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_126d1c7d-bc6f-46b5-ae69-9440d5c08991",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Benny's On The Beach",
      "poi_type": "Restaurants",
      "poi_address": "10 S Ocean Blvd, Lake Worth Beach, FL 33460, USA",
      "poi_short_description": "Unassuming eatery offers all-American fare for breakfast & lunch, plus bonus ocean views.",
      "poi_long_description": "People say this restaurant offers delicious seafood, including fish tacos, lobster rolls, and shrimp and grits, as well as a popular key lime pie and pina colada. They also highlight the beautiful ocean views, outdoor seating, and live music, creating a relaxing and enjoyable atmosphere.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7573-765c-bd98-6b5a409dfbf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7573-765c-bd98-6b5a409dfbf1",
        "storage_key": "property/6767906449167533/019eae0a-7573-765c-bd98-6b5a409dfbf1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bennysonthebeach.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14768110651114030436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bennys-on-the-beach",
      "poi_latitude": "26.6128207",
      "poi_longitude": "-80.0367395",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 561-582-9001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac1-75c9-9e8f-d698b9db1b52",
        "storage_key": "property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6nvbMfZ2IgRZIVQc2Te8sw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_48421807-4a04-4d36-851a-efdfc4b8c927",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Old Key Lime House",
      "poi_type": "Restaurants",
      "poi_address": "300 E Ocean Ave, Lantana, FL 33462, USA",
      "poi_short_description": "Palapa-roofed hut & historic house with regular live tunes, casual seafood & Intracoastal views.",
      "poi_long_description": "Diners praise this restaurant's delicious seafood, particularly the fresh grouper and crab cakes, along with their famous Key Lime Pie. The lively atmosphere is also a highlight, featuring live music, waterfront views, and friendly staff.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7640-73e8-8ca7-5042d9a1b5da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7640-73e8-8ca7-5042d9a1b5da",
        "storage_key": "property/6767906449167533/019eae0a-7640-73e8-8ca7-5042d9a1b5da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.oldkeylimehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9171465947817777522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-key-lime-house",
      "poi_latitude": "26.5839255",
      "poi_longitude": "-80.04890449999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 561-582-1889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac1-75c9-9e8f-d698b9db1b52",
        "storage_key": "property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqSZjQwHZ2IgRchlF4a-XR38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_522c3526-7b44-439c-a310-8359c535856d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Two Georges Waterfront Grille",
      "poi_type": "Restaurants",
      "poi_address": "728 Casa Loma Blvd, Boynton Beach, FL 33435, USA",
      "poi_short_description": "Lively destination offering seafood classics & cocktails, plus waterfront views.",
      "poi_long_description": "Diners like this restaurant's delicious fresh seafood, including the blackened mahi sandwich and conch fritters, and appreciate the lively atmosphere with live music and waterfront views. They also highlight the friendly and attentive staff, as well as the reasonable prices and convenient parking options.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-71a2-742b-a6d4-83f1005a410d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-71a2-742b-a6d4-83f1005a410d",
        "storage_key": "property/6767906449167533/019eae0a-71a2-742b-a6d4-83f1005a410d.webp",
        "width": 1280,
        "height": 860
      },
      "poi_business_url": "https://twogeorgesrestaurant.com/boynton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=528552235067009139&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "two-georges-waterfront-grille",
      "poi_latitude": "26.5278735",
      "poi_longitude": "-80.05438079999999",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 561-736-2717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac1-75c9-9e8f-d698b9db1b52",
        "storage_key": "property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7cVdyff2IgRc2hoGHXLVQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_d15948d2-9d83-4b64-b417-cbbfc8639098",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "389 Winchester Park Blvd, Boynton Beach, FL 33436, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh and hot food, including steak, chicken, soup, salad, and a selection of desserts. They also highlight the affordable prices, friendly and attentive service, and clean environment.\n\nOther reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-6fef-76a9-b436-e7bbfae5a07f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-6fef-76a9-b436-e7bbfae5a07f",
        "storage_key": "property/6767906449167533/019eae0a-6fef-76a9-b436-e7bbfae5a07f.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/2457/golden-corral-winchester-park-blvd?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2457",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217254673248414672&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "26.529463",
      "poi_longitude": "-80.094268",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 561-733-3787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac1-75c9-9e8f-d698b9db1b52",
        "storage_key": "property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQWOFFnf2IgR0OvX6Bgfbbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_4809ba42-f6cc-484b-8b55-c5b69d1a3244",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1550 Boynton Beach Blvd, Boynton Beach, FL 33436, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves hot, fresh, and delicious chicken fingers, fries, and Texas toast. They also highlight the friendly staff, clean atmosphere, and upbeat vibe.\n\nOther reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7318-703b-a48e-4c0295681a2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7318-703b-a48e-4c0295681a2f",
        "storage_key": "property/6767906449167533/019eae0a-7318-703b-a48e-4c0295681a2f.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/fl/boynton-beach/1550-west-boynton-beach-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=15310075956457076222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "26.5270413",
      "poi_longitude": "-80.09401419999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 561-237-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac1-75c9-9e8f-d698b9db1b52",
        "storage_key": "property/6767906449167533/019eae0a-aac1-75c9-9e8f-d698b9db1b52.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbcs7OXnf2IgR_nXfVPdQeNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_42ab31b1-892c-41ac-86ea-2e1329690445",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7395 Boynton Beach Blvd, Boynton Beach, FL 33437, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, bakery items, and high-quality meat and fish, with many organic and healthy options. They also highlight the clean, well-organized store, helpful staff, and convenient Amazon return and pickup services.\n\nSome reviews mention the prepared foods can be old.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7365-74ef-ade7-30791e4a42a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7365-74ef-ade7-30791e4a42a0",
        "storage_key": "property/6767906449167533/019eae0a-7365-74ef-ade7-30791e4a42a0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/boyntonbeach?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=15701391146675678358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "26.5293032",
      "poi_longitude": "-80.1630182",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 561-327-6270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac4-775b-a344-9523d2b5fe6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac4-775b-a344-9523d2b5fe6b",
        "storage_key": "property/6767906449167533/019eae0a-aac4-775b-a344-9523d2b5fe6b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSX2dAAh2YgRliwR8Q6M5tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6fe7b188-2eb2-4ce5-8cdb-50d29890aa67",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7233 N Seacrest Blvd, Lantana, FL 33462, USA",
      "poi_short_description": "Chain for DIY enthusiasts featuring home improvement supplies, appliances and gardening items.",
      "poi_long_description": "People say this home improvement store offers a wide selection of plants, orchids, and home repair items, and is clean, well-stocked, and brand new. They also highlight the friendly, helpful, and knowledgeable staff who provide excellent customer service.\n\nSome reviews mention the customer service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7249-7435-9587-10c134344f2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7249-7435-9587-10c134344f2e",
        "storage_key": "property/6767906449167533/019eae0a-7249-7435-9587-10c134344f2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Lantana/FL/Lantana/33462/3118?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3826985140022504337&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "26.5695752",
      "poi_longitude": "-80.0680431",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 561-764-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac5-771b-87a4-8c99ed0ad9e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac5-771b-87a4-8c99ed0ad9e9",
        "storage_key": "property/6767906449167533/019eae0a-aac5-771b-87a4-8c99ed0ad9e9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq2BuL_HZ2IgRkWu9Z7UuHDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_0b5d7aeb-fba0-4876-9401-9bb5597075ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Palm Beach State College",
      "poi_type": "Education",
      "poi_address": "4200 S Congress Ave, Lake Worth Beach, FL 33461, USA",
      "poi_short_description": "Campus bookstore chain offering new, used & digital textbooks, plus school-branded merchandise.",
      "poi_long_description": "Campus bookstore chain offering new, used & digital textbooks, plus school-branded merchandise.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-78a0-728d-965b-30dc3f00e776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-78a0-728d-965b-30dc3f00e776",
        "storage_key": "property/6767906449167533/019eae0a-78a0-728d-965b-30dc3f00e776.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://pbsc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14710660417764776862&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palm-beach-state-college",
      "poi_latitude": "26.6119841",
      "poi_longitude": "-80.08690179999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 561-868-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac4-775b-a344-98c9cfc95d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac4-775b-a344-98c9cfc95d1d",
        "storage_key": "property/6767906449167533/019eae0a-aac4-775b-a344-98c9cfc95d1d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh-7Tu3LY2IgRnttEpLXDJsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a8cfc813-affb-4c09-b68e-4ba3ff495314",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Boynton Beach City Library",
      "poi_type": "Education",
      "poi_address": "100 E Ocean Ave, Boynton Beach, FL 33435, USA",
      "poi_short_description": "Colorful and spacious, this modern library featuring kids' sections and events, plus a friendly staff.",
      "poi_long_description": "People say this library offers a huge variety of books, DVDs, and research materials, along with computers and printers. Visitors also highlight the spotless, welcoming, and well-organized facility, noting it's perfect for studying. They also mention the staff are friendly, helpful, and knowledgeable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7d95-743e-a3f3-905580dccf61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7d95-743e-a3f3-905580dccf61",
        "storage_key": "property/6767906449167533/019eae0a-7d95-743e-a3f3-905580dccf61.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://boyntonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11958460016774361296&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boynton-beach-city-library",
      "poi_latitude": "26.5266635",
      "poi_longitude": "-80.06334310000001",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 561-742-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aac4-775b-a344-98c9cfc95d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aac4-775b-a344-98c9cfc95d1d",
        "storage_key": "property/6767906449167533/019eae0a-aac4-775b-a344-98c9cfc95d1d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6WpIniTf2IgR0DCM0Ab89KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_fff80227-4c70-4b76-b864-7b2b8a670856",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Safari Bob's",
      "poi_type": "Entertainment",
      "poi_address": "6598 Nova Ln, Atlantis, FL 33462, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7b9e-7201-897a-0b21cb2ce986.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7b9e-7201-897a-0b21cb2ce986",
        "storage_key": "property/6767906449167533/019eae0a-7b9e-7201-897a-0b21cb2ce986.webp",
        "width": 1146,
        "height": 974
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15916389831478148231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safari-bobs",
      "poi_latitude": "26.578274",
      "poi_longitude": "-80.10771079999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 561-351-5684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5RYOvcn2YgRh_zkGzlg4tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_14c12e86-42a7-4650-8231-c64fffeb3fa6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Museum 66 - Boynton Beach",
      "poi_type": "Entertainment",
      "poi_address": "2051 High Ridge Rd, Boynton Beach, FL 33426, USA",
      "poi_short_description": "Home to a collection of American classic cars and sports cars, open by appointment for tours and events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7708-760c-a496-45b46adc1f61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7708-760c-a496-45b46adc1f61",
        "storage_key": "property/6767906449167533/019eae0a-7708-760c-a496-45b46adc1f61.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "http://www.museum66.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10266033366707927752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-66---boynton-beach",
      "poi_latitude": "26.5475406",
      "poi_longitude": "-80.07436369999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 561-325-8875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aada-7316-8e63-9b77ff2fec38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aada-7316-8e63-9b77ff2fec38",
        "storage_key": "property/6767906449167533/019eae0a-aada-7316-8e63-9b77ff2fec38.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3cqXXcrY2IgRyPruivRGeI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1d7bab0d-b02d-46de-989a-5c23a80bbcaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Museum of Polo & Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "9011 Lake Worth Rd, Wellington, FL 33467, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-7cde-71de-b171-1ae0b573fb90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-7cde-71de-b171-1ae0b573fb90",
        "storage_key": "property/6767906449167533/019eae0a-7cde-71de-b171-1ae0b573fb90.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://polomuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=117444566563961213&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-polo--hall-of-fame",
      "poi_latitude": "26.6178245",
      "poi_longitude": "-80.19037829999999",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 561-969-3210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aada-7316-8e63-9b77ff2fec38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aada-7316-8e63-9b77ff2fec38",
        "storage_key": "property/6767906449167533/019eae0a-aada-7316-8e63-9b77ff2fec38.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJxX6M5d4l2YgRfTnYBjY_oQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5959ea75-f691-4c65-9fc1-8292b19422c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Dr. Joaquín García High School Bulldog Stadium",
      "poi_type": "Entertainment",
      "poi_address": "JR37+93, Wellington, FL 33467, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-8065-7119-bad3-355dcc0260f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-8065-7119-bad3-355dcc0260f2",
        "storage_key": "property/6767906449167533/019eae0a-8065-7119-bad3-355dcc0260f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1627779119722593313&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dr-joaqun-garca-high-school-bulldog-stadium",
      "poi_latitude": "26.6034375",
      "poi_longitude": "-80.18731249999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aafd-73ca-b532-2550b4087b69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aafd-73ca-b532-2550b4087b69",
        "storage_key": "property/6767906449167533/019eae0a-aafd-73ca-b532-2550b4087b69.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmYyPXAAn2YgRIfzcK3wIlxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_379fa9cd-c6b9-4a99-a740-9c63f8df67ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Opus 14 Sea Turtle",
      "poi_type": "Entertainment",
      "poi_address": "6415N N Ocean Blvd, Ocean Ridge, FL 33435, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-83f3-70df-8600-6eaa58bd1ebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-83f3-70df-8600-6eaa58bd1ebd",
        "storage_key": "property/6767906449167533/019eae0a-83f3-70df-8600-6eaa58bd1ebd.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10592830454789425533&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "opus-14-sea-turtle",
      "poi_latitude": "26.5301964",
      "poi_longitude": "-80.0471944",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwogaK_f2IgRfcmp5yxLAZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_c0630bd3-61c7-4e47-89f3-ac498d8cadd6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1775 N Congress Ave Suite B, Boynton Beach, FL 33426, USA",
      "poi_short_description": "Sizable gym featuring group classes, plus weights and cardio machines in a theater-style setup.",
      "poi_long_description": "People say this gym offers a wide variety of modern equipment, including numerous cardio machines, free weights, and resistance machines, along with amenities like saunas, cold plunges, and a movie theater room. They also highlight the affordable pricing and the consistently clean and well-maintained facility. Visitors appreciate the friendly, welcoming, and knowledgeable staff who provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-812c-728f-ad25-1fa4aec466e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-812c-728f-ad25-1fa4aec466e5",
        "storage_key": "property/6767906449167533/019eae0a-812c-728f-ad25-1fa4aec466e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/boynton-beach-n-congress-ave-e-gateway-blvd/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9999476245893040267&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "26.5435406",
      "poi_longitude": "-80.0920063",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 561-922-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8Hu07Pf2IgRi0hpiKpGxYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3e319ccd-b9a7-4f94-b724-800a32e3689d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Crunch Fitness - Lake Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "4681 Hypoluxo Rd, Lake Worth Beach, FL 33463, USA",
      "poi_short_description": "",
      "poi_long_description": "Reviewers consistently praise this gym for its wide variety of modern equipment, including numerous machines and many free weights, alongside its great fitness classes. The clean facilities, friendly staff, and positive atmosphere are also frequently highlighted.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-830d-7089-b91e-edfad6c4f8d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-830d-7089-b91e-edfad6c4f8d7",
        "storage_key": "property/6767906449167533/019eae0a-830d-7089-b91e-edfad6c4f8d7.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/lake-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=15277019199677515455&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---lake-worth",
      "poi_latitude": "26.573063",
      "poi_longitude": "-80.1162861",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 561-896-9080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VZPLCUn2YgRv8aZXwXgAtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9e209da7-15c2-4ca1-a06c-c7d10dc56792",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Crunch Fitness - Greenacres",
      "poi_type": "Health and Wellness",
      "poi_address": "6846 Forest Hill Blvd, Greenacres, FL 33413, USA",
      "poi_short_description": "Gym chain offering month-to-month memberships, plus personal training and group classes.",
      "poi_long_description": "People say this gym offers a variety of classes and has a sauna.\n\nOther reviews mention the membership can be difficult to cancel and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-858c-711b-827c-caaf27ad7c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-858c-711b-827c-caaf27ad7c16",
        "storage_key": "property/6767906449167533/019eae0a-858c-711b-827c-caaf27ad7c16.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/greenacres",
      "poi_directions_map_url": "https://maps.google.com/?cid=11099056675802603248&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---greenacres",
      "poi_latitude": "26.6494704",
      "poi_longitude": "-80.1501595",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 561-369-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5byl9w4p2YgR8F4kxz3FB5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bb2e548b-761d-4a3a-bddf-f09b29221a38",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "DeVos-Blum Family YMCA of Boynton Beach",
      "poi_type": "Health and Wellness",
      "poi_address": "9600 S Military Trl, Boynton Beach, FL 33436, USA",
      "poi_short_description": "Family-friendly non-profit with a heated pool, fitness classes, and child care.",
      "poi_long_description": "People say this gym offers a nice variety of well-maintained equipment and a zero-entry pool for kids. They also highlight the friendly staff, clean facility, and great classes and activities, including yoga, Pound, and Zumba.\n\nOther reviews mention the communication can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-84a8-7245-8ca1-96a32a3e559b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-84a8-7245-8ca1-96a32a3e559b",
        "storage_key": "property/6767906449167533/019eae0a-84a8-7245-8ca1-96a32a3e559b.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.ymcaspbc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13021875246884552039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "devos-blum-family-ymca-of-boynton-beach",
      "poi_latitude": "26.5326537",
      "poi_longitude": "-80.1220129",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 561-738-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-Bpvccg2YgRZ30BUIv-trQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f3b1a412-726a-4518-a5d8-e054f81387fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Paws 2 Help Inc.",
      "poi_type": "Health and Wellness",
      "poi_address": "2693 Forest Hill Blvd, West Palm Beach, FL 33406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-8721-74b9-8fcb-dee182bda083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-8721-74b9-8fcb-dee182bda083",
        "storage_key": "property/6767906449167533/019eae0a-8721-74b9-8fcb-dee182bda083.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://paws2help.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9968692683134723467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paws-2-help-inc",
      "poi_latitude": "26.651044",
      "poi_longitude": "-80.0837504",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 561-712-1911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-3AE-d0p2YgRi-VHzS3pV4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_1c4d06e9-1dee-400e-b0ee-e3ef4be20feb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2290 N Congress Ave, Boynton Beach, FL 33426, USA",
      "poi_short_description": "Health club chain offering state-of-the-art facilities, including cardio and weight machines, plus pools and a basketball court.",
      "poi_long_description": "Reviewers praise this gym for its nice-sized pool and whirlpool, along with a spacious facility that is not overcrowded.\n\nOther reviews mention the facility can be poorly maintained and neglected.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-887a-7508-93e9-3b43a2430c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-887a-7508-93e9-3b43a2430c65",
        "storage_key": "property/6767906449167533/019eae0a-887a-7508-93e9-3b43a2430c65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=255&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8247442708267544259&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "26.5499194",
      "poi_longitude": "-80.08921579999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 561-364-5766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYR4zxq3Y2IgRwy6sQ3LNdHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0a3e52a5-aa4b-4d66-8b87-98b4a3051f56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9764 S Military Trl, Boynton Beach, FL 33436, USA",
      "poi_short_description": "Chain gym with tanning beds, massage chairs, and hydro massages at Boynton Trail Centre.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including arc trainers, and a hot/cold compression chair. They also highlight the clean and neat facilities, the friendly and helpful staff, and the convenient hours of operation.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-87d2-7135-b1a5-0e6c4a50da8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-87d2-7135-b1a5-0e6c4a50da8b",
        "storage_key": "property/6767906449167533/019eae0a-87d2-7135-b1a5-0e6c4a50da8b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/boynton-beach-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1513695323945456525&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "26.5313203",
      "poi_longitude": "-80.1206078",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 561-810-5520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdwZYMcg2YgRjVPwkeC5ARU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a485a9c8-3f40-4e67-8284-b3693a58b0e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "HCA Florida JFK Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 S Congress Ave, Atlantis, FL 33462, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-8a05-7625-8c68-a8995d0e97e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-8a05-7625-8c68-a8995d0e97e6",
        "storage_key": "property/6767906449167533/019eae0a-8a05-7625-8c68-a8995d0e97e6.webp",
        "width": 798,
        "height": 449
      },
      "poi_business_url": "https://www.hcafloridahealthcare.com/locations/jfk-hospital/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10877799114479779723&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hca-florida-jfk-hospital",
      "poi_latitude": "26.5984627",
      "poi_longitude": "-80.0909872",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 561-965-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab05-731b-9768-df3a25bb236d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab05-731b-9768-df3a25bb236d",
        "storage_key": "property/6767906449167533/019eae0a-ab05-731b-9768-df3a25bb236d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJA-z88HvY2IgRiz-gXKm09ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_15dcbfd5-600c-494c-807e-af83e0150af3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Baptist Health Bethesda Hospital East",
      "poi_type": "Health and Wellness",
      "poi_address": "2815 S Seacrest Blvd, Boynton Beach, FL 33435, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-8b42-76da-a5eb-a26707457a79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-8b42-76da-a5eb-a26707457a79",
        "storage_key": "property/6767906449167533/019eae0a-8b42-76da-a5eb-a26707457a79.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://baptisthealth.net/locations/hospitals/bethesda-hospital-east?utm_source=yext&utm_medium=google&utm_campaign=listing&y_source=1_MTIwNTAyMzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=891484788841048538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baptist-health-bethesda-hospital-east",
      "poi_latitude": "26.504293",
      "poi_longitude": "-80.0704422",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 561-737-7733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab05-731b-9768-df3a25bb236d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab05-731b-9768-df3a25bb236d",
        "storage_key": "property/6767906449167533/019eae0a-ab05-731b-9768-df3a25bb236d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzsqZW3f2IgR2umIMbEwXww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_11db9b48-025f-427e-8ead-3f6fe122f7e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Lake Worth Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10 S Ocean Blvd Unit #7, Lake Worth Beach, FL 33460, USA",
      "poi_short_description": "Sandy ocean beach area with restaurants, shops & a pier for fishing & walking.",
      "poi_long_description": "People say this park offers a beautiful, clean beach with clear water, a pier for fishing and walking, and nearby restaurants and shops. They highlight the easy parking, convenient access to the beach, and the presence of lifeguards and showers. They also like the friendly staff and the family-friendly vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-8bbd-73fc-8eb9-3ace3893a944.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-8bbd-73fc-8eb9-3ace3893a944",
        "storage_key": "property/6767906449167533/019eae0a-8bbd-73fc-8eb9-3ace3893a944.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2064714312646444521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-worth-beach-park",
      "poi_latitude": "26.6147075",
      "poi_longitude": "-80.03721639999999",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 561-585-6858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aaec-73bc-bfb2-fadc36c91636.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aaec-73bc-bfb2-fadc36c91636",
        "storage_key": "property/6767906449167533/019eae0a-aaec-73bc-bfb2-fadc36c91636.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6z7GtMbZ2IgR6cX0X7pWpxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_57ac2e35-88d5-4cbf-81c1-b79b0246d301",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "John Prince Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2700 6th Ave S, Lake Worth Beach, FL 33461, USA",
      "poi_short_description": "726-acre outdoor haven with campgrounds, ball fields, playgrounds & a golf center.",
      "poi_long_description": "People say this park offers a wide variety of activities, including sports fields, playgrounds, a dog park, and a lake with water activities. They highlight the well-maintained facilities, clean restrooms, and ample parking. They also like the scenic trails, shade from trees, and opportunities for wildlife viewing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-8fff-709c-abac-ed96c824fa36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-8fff-709c-abac-ed96c824fa36",
        "storage_key": "property/6767906449167533/019eae0a-8fff-709c-abac-ed96c824fa36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://discover.pbcgov.org/parks/Locations/John-Prince.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16888732232608961020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-prince-park",
      "poi_latitude": "26.604446",
      "poi_longitude": "-80.082825",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 561-966-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aaec-73bc-bfb2-fadc36c91636.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aaec-73bc-bfb2-fadc36c91636",
        "storage_key": "property/6767906449167533/019eae0a-aaec-73bc-bfb2-fadc36c91636.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_kEsmTY2IgR_NFYN3zUYOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b1743832-7783-4033-a460-dcd40eed33dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Ocean Inlet Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6990 N Ocean Blvd, Boynton Beach, FL 33435, USA",
      "poi_short_description": "Set on the ocean, this public area offers swimming, kayaking & fishing, plus picnic spots.",
      "poi_long_description": "People say this park offers a beach, pier, and inlet, with opportunities for swimming, fishing, and boating. They highlight the free parking, clean restrooms, and scenic views, especially at sunset. They also like the family-friendly atmosphere and the availability of picnic tables and grills. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-8c78-716c-afbf-a0d8ff8fbcb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-8c78-716c-afbf-a0d8ff8fbcb0",
        "storage_key": "property/6767906449167533/019eae0a-8c78-716c-afbf-a0d8ff8fbcb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://discover.pbcgov.org/parks/Locations/Ocean-Inlet.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11043522823847595554&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ocean-inlet-park",
      "poi_latitude": "26.5452653",
      "poi_longitude": "-80.04423059999999",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 561-966-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aaec-73bc-bfb2-fadc36c91636.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aaec-73bc-bfb2-fadc36c91636",
        "storage_key": "property/6767906449167533/019eae0a-aaec-73bc-bfb2-fadc36c91636.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWpxcy3Z2IgRIs5aSH95Qpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e597d355-388b-44de-8db3-5583c8f4af4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Ocean Front Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6415N N Ocean Blvd, Ocean Ridge, FL 33435, USA",
      "poi_short_description": "Beach with warm waters, and picnic tables.",
      "poi_long_description": "People say this beach offers a clean and beautiful environment with plenty of space, and it's not usually too crowded. Visitors also highlight the clean bathrooms, outdoor rinse-off areas, and available beach wheelchairs. They also like the attentive lifeguards and accessible parking options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-8ed5-718e-af61-4b1e215b1f07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-8ed5-718e-af61-4b1e215b1f07",
        "storage_key": "property/6767906449167533/019eae0a-8ed5-718e-af61-4b1e215b1f07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.boynton-beach.org/beach/oceanfront-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3851212384317443769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ocean-front-beach-park",
      "poi_latitude": "26.5308573",
      "poi_longitude": "-80.047474",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 561-742-6775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aaec-73bc-bfb2-fadc36c91636.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aaec-73bc-bfb2-fadc36c91636",
        "storage_key": "property/6767906449167533/019eae0a-aaec-73bc-bfb2-fadc36c91636.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8bjG_rf2IgRuY7TSUJBcjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ec4a50d2-d5ef-4324-baab-e2d757858a80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Westchester Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12250 Westchester Club Dr, Boynton Beach, FL 33437, USA",
      "poi_short_description": "Golf course offering 27 championship holes, a driving range, and banquet halls.",
      "poi_long_description": "Visitors say this golf course features a good layout with wide fairways, well-maintained greens, and good practice facilities. They also highlight the reasonable fees, friendly staff, and enjoyable happy hour events with live music and appetizers.\n\nSome reviews mention the greens can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-a374-7668-8415-1830411abc8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-a374-7668-8415-1830411abc8f",
        "storage_key": "property/6767906449167533/019eae0a-a374-7668-8415-1830411abc8f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.westchestercc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16431449667911609925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westchester-country-club",
      "poi_latitude": "26.4955169",
      "poi_longitude": "-80.14574139999999",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 561-369-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-aafa-7445-ba1f-8d12f95662a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-aafa-7445-ba1f-8d12f95662a9",
        "storage_key": "property/6767906449167533/019eae0a-aafa-7445-ba1f-8d12f95662a9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTnnX6wh2YgRRe6UWGo8COQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_29cb738b-68e1-4664-a492-f96d0a5058b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Lake Worth Beach",
      "poi_type": "Transportation & Transit",
      "poi_address": "1703 Lake Worth Rd, Lake Worth Beach, FL 33461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-918b-70f5-9700-8c1555404ae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-918b-70f5-9700-8c1555404ae2",
        "storage_key": "property/6767906449167533/019eae0a-918b-70f5-9700-8c1555404ae2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tri-rail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6445959602946720065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-worth-beach",
      "poi_latitude": "26.6161091",
      "poi_longitude": "-80.06902170000001",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-874-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ada3-754a-83d2-efe6be924f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ada3-754a-83d2-efe6be924f68",
        "storage_key": "property/6767906449167533/019eae0a-ada3-754a-83d2-efe6be924f68.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8lr3DjY2IgRQUEoUhumdFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_87c94efb-e0b2-496f-b410-6193329e96cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Boynton Beach",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 High Ridge Rd, Boynton Beach, FL 33426, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-9179-745c-a0ea-ac9a524d7722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-9179-745c-a0ea-ac9a524d7722",
        "storage_key": "property/6767906449167533/019eae0a-9179-745c-a0ea-ac9a524d7722.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tri-rail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11197768361003610942&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boynton-beach",
      "poi_latitude": "26.553783",
      "poi_longitude": "-80.07059699999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-783-6030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ada3-754a-83d2-efe6be924f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ada3-754a-83d2-efe6be924f68",
        "storage_key": "property/6767906449167533/019eae0a-ada3-754a-83d2-efe6be924f68.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2Vew8jY2IgRPnO6-v52Zps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_20bc8395-c315-4015-9d93-85a07f05e85b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Palm Beach County Park/Lantana Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2633 Lantana Rd, Lake Worth Corridor, FL 33462, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-9fb6-767b-87fc-2cb0bdbea93f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-9fb6-767b-87fc-2cb0bdbea93f",
        "storage_key": "property/6767906449167533/019eae0a-9fb6-767b-87fc-2cb0bdbea93f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://discover.pbc.gov/Airports/Pages/Park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3262554507211829191&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palm-beach-county-parklantana-airport",
      "poi_latitude": "26.5888938",
      "poi_longitude": "-80.08509819999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 561-656-9815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ada7-71bf-962e-df17dceddc7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ada7-71bf-962e-df17dceddc7c",
        "storage_key": "property/6767906449167533/019eae0a-ada7-71bf-962e-df17dceddc7c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJZf6b3GLY2IgRx--13gnsRi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_228268ac-9365-415e-b9c6-c4433be2b0a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "City of Boynton Beach",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 E Ocean Ave, Boynton Beach, FL 33435, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-931a-7246-83a3-e195d58c1f90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-931a-7246-83a3-e195d58c1f90",
        "storage_key": "property/6767906449167533/019eae0a-931a-7246-83a3-e195d58c1f90.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.boynton-beach.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15669233130045102881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-boynton-beach",
      "poi_latitude": "26.526664",
      "poi_longitude": "-80.06334310000001",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 561-742-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-adeb-747c-b81d-9113e5e6d332.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-adeb-747c-b81d-9113e5e6d332",
        "storage_key": "property/6767906449167533/019eae0a-adeb-747c-b81d-9113e5e6d332.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTd-4CTf2IgRIdseO4NMdNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_54b14829-0596-4ad9-a3d2-69e547908929",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Palm Beach Accountable Care Organization, LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2326 S Congress Ave, Palm Springs, FL 33406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-a0cf-7689-91db-0a3d9c259025.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-a0cf-7689-91db-0a3d9c259025",
        "storage_key": "property/6767906449167533/019eae0a-a0cf-7689-91db-0a3d9c259025.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.pbaco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16947411798025250153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palm-beach-accountable-care-organization-llc",
      "poi_latitude": "26.6424135",
      "poi_longitude": "-80.0874468",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 561-429-2680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrx1YwfnX2IgRaSWPMz1NMes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_906706dd-69a9-4f9b-9fb4-56c805cda9ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "City of Lake Worth Beach City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7 N Dixie Hwy, Lake Worth Beach, FL 33460, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-a009-76c1-80bc-09ffd6732687.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-a009-76c1-80bc-09ffd6732687",
        "storage_key": "property/6767906449167533/019eae0a-a009-76c1-80bc-09ffd6732687.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lakeworth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8931481007558602066&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-lake-worth-beach-city-hall",
      "poi_latitude": "26.6162913",
      "poi_longitude": "-80.05787149999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-adeb-747c-b81d-9113e5e6d332.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-adeb-747c-b81d-9113e5e6d332",
        "storage_key": "property/6767906449167533/019eae0a-adeb-747c-b81d-9113e5e6d332.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTX-dDjZ2IgRUq2txaf-8ns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_de883e11-437b-4c6a-943d-a26cba88cbde",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "Haven Health Management",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2925 10th Ave N, Palm Springs, FL 33461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-a590-779f-b112-90aaabed46f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-a590-779f-b112-90aaabed46f8",
        "storage_key": "property/6767906449167533/019eae0a-a590-779f-b112-90aaabed46f8.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://havenhealthmgmt.org/?utm_campaign=HHM_Organic&utm_medium=Organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=10925728421786213793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haven-health-management",
      "poi_latitude": "26.6290711",
      "poi_longitude": "-80.08751219999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 561-867-4112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhYtYfADZ2IgRod301Bz8n5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_52e1201f-baaa-4ba5-9c55-8d49c1b95a1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "custom",
      "poi_name": "EcoCentre",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1005 Lake Ave, Lake Worth Beach, FL 33460, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-a591-748d-a92f-11d39d9e0148.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eae0a-a591-748d-a92f-11d39d9e0148",
        "storage_key": "property/6767906449167533/019eae0a-a591-748d-a92f-11d39d9e0148.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2616314026381010147&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ecocentre",
      "poi_latitude": "26.6157038",
      "poi_longitude": "-80.0586115",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eae0a-ab02-710f-809b-5b3c3798c9a4",
        "storage_key": "property/6767906449167533/019eae0a-ab02-710f-809b-5b3c3798c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwX4v0zXY2IgR4-RPw74DTyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d80249ff-7f6d-437e-a468-1dec0c77d929",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4cb4023f-4c50-4bca-8f5e-672cfc1a8228",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c972d10b-bd8f-416e-887d-92097233bfd5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6d5325be-f619-4954-aecb-bf39947efa8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_eece0030-58aa-4a98-8fba-22873e7b6c9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6d92df34-2d45-4776-8da1-6183e3f29e70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4c95fff7df3c19227e1af725",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "rating": "5",
      "name": "Tiny Brown",
      "text": "Maintenance Crew\nThe maintenance manager yasmi and her team deserves a serious shout-out. They are kind, friendly, and incredibly helpful—the kind of professionals you’re happy to see at your door. Requests are handled quickly and done right the first time, and they always check in to make sure everything is working the way it should. That reliability makes apartment living stress-free.\nFlorence – Property Manager\nFlorence sets the tone for the entire community. Her leadership shows in the way Savona Grand runs—organized, responsive, and resident-focused. Any time there’s a policy update, a question about renewals, or a community concern, Florence communicates clearly and follows through. You can feel Florence pride in keeping Savona Grand safe, beautiful, and consistent year after year.",
      "date": "2026-05-18",
      "title": "false"
    },
    {
      "id": "ec_a8acd4c6577f397c1733d8c3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "rating": "5",
      "name": "Fabiola Joseph",
      "text": "If you’re considering moving here as a new resident, I’d absolutely recommend taking that step. My experience from start to now has been nothing short of top-notch. Lucas is phenomenal , he conducted the welcome tour and the experience alone made my mind up about saying yes to the property. The application process was super easy not complicating at all. Florence and Edwidge are just as amazing, they made my move-in process smooth and stress-free, and they’ve continued to respond quickly to anything I’ve needed since.\n\nIt’s clear the team truly cares about both the property and the residents. I also want to recognize the Maintenance Supervisor, Yasmi, she’s been exceptional, and I truly appreciate all the support she’s given during my move-in experience. I haven’t met the rest of the maintenance team personally, but every time I see them, they’re friendly, smiling, and welcoming, which really makes me feel at home.\n\nI love it here and the units are so beautiful.",
      "date": "2026-03-26",
      "title": "false"
    },
    {
      "id": "ec_4b74f68cbfa723c5e57ee382",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "rating": "5",
      "name": "FlowerPower",
      "text": "I’ve lived at Savona Grand for about three years now, and I’ve seen the community go through a lot of changes during that time. Earlier this year, I was honestly considering giving notice and looking for somewhere new. However, since Florence became the manager, I’ve noticed a huge difference in the overall atmosphere of the property.\n\nThe community has become noticeably cleaner and much more peaceful. The breezeways, grounds, and shared spaces are being kept up far better than before, and you can really tell there’s more attention being given to the details that make a place feel like home.\n\nAnother thing that stands out is how quickly and efficiently maintenance requests are handled. Work orders are addressed promptly, and the maintenance team does a great job communicating and making sure issues are resolved the right way the first time.\n\nIt’s clear that management is making a real effort to improve the community and take care of the residents. Because of the positive changes over the past few months, I’ve decided to stay and renew my lease. It’s nice to see Savona Grand moving in such a good direction.",
      "date": "2026-03-16",
      "title": "false"
    },
    {
      "id": "ec_2fcda80ccf69f29cc41276bc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "rating": "5",
      "name": "Wayne Parchment",
      "text": "I recently moved into the community a few months ago, and I absolutely love the property! Mrs. Florence and the staff are friendly and attentive; the maintenance manager, Ms.Yasmi, and Rohan always answers maintenance requests and has gone above and beyond to make sure the job gets done. I can truly say the office staff genuinely cares about the cleanliness and overall safety of the community. It is a safe place to call home and a perfect blend for families with children. I am happy to be here and look forward to years ahead; I definitely will be renewing my lease.\nThank you, Savona Grand.\nSigned Ferneisha",
      "date": "2026-01-29",
      "title": "false"
    },
    {
      "id": "ec_28d97ba4c97e03d9036abf4d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "rating": "5",
      "name": "Eddy Royale",
      "text": "I’d like to give a warm shout-out to our wonderful new office staff, especially Mama Florence, who’s truly amazing. A big thank you also goes to our new maintenance team—there have been so many great improvements around the property! I’m grateful for all the incredible people making these positive changes happen. Your hard work and dedication are truly appreciated!",
      "date": "2026-03-03",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019f047b-f714-71e9-b282-918ab9182562",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "american-landmark-savona-grand",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "apartments-with-pool-lake-worth-beach-savona-grand",
      "search_query": "apartments with pool Lake Worth Beach",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Lake Worth Beach",
      "h2_subtitle": "Discover perfect apartments with pool access in Lake Worth Beach. Enjoy modern amenities and a great location at Savona Grand.",
      "page_copy": "At Savona Grand, you'll find polished Palm Beach County apartment living enhanced by a sparkling pool—perfect for soaking up the Florida sunshine. Situated beside serene ponds, our community offers floor plans ranging from one to three bedrooms, complete with full-size washers and dryers, expansive storage, and select upgraded finishes.\n\nEnjoy active amenities including a tennis court and pickleball court, as well as practical features like a car care station. Located in the vibrant Outer Boynton Beach neighborhood, Savona Grand offers convenient access to local attractions and everything Lake Worth Beach has to offer, ensuring an all-around remarkable living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool | Lake Worth Beach",
      "seo_description": "Discover apartments with a pool in Lake Worth Beach at Savona Grand. Enjoy spacious floor plans and various amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "dog-park-apartments-palm-beach-county-savona-grand",
      "search_query": "dog park apartments Palm Beach County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Palm Beach County",
      "h2_subtitle": "Savona Grand offers dog park apartments in Palm Beach County. Perfect for pet owners seeking spacious and comfortable living.",
      "page_copy": "At Savona Grand, pet-friendly living meets modern elegance. Perfectly situated in Palm Beach County’s Outer Boynton Beach, our community boasts amenities like a dedicated dog park, ensuring a welcoming environment for pet lovers and their four-legged friends. Explore our spacious one-, two-, and three-bedroom apartments, outfitted with full-size washers and dryers, generous storage solutions, and select upgraded finishes.\n\nBeyond pet-friendly facilities, residents of Savona Grand enjoy access to fun lifestyle amenities, including a tennis and pickleball court. Vaulted ceilings and hardwood-style plank flooring add a touch of luxury to your space. Discover the scenic beauty surrounding our Lake Worth Beach location while enjoying convenient access to all the best of Palm Beach County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments | Palm Beach County",
      "seo_description": "Choose Savona Grand for dog park apartments in Palm Beach County. Enjoy pet-friendly amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-33463-savona-grand",
      "search_query": "in-unit laundry apartments 33463",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in 33463",
      "h2_subtitle": "Savona Grand offers in-unit laundry apartments in the 33463 area. Experience convenience and comfort in Lake Worth Beach.",
      "page_copy": "Savona Grand is your destination for in-unit laundry apartments conveniently located in Lake Worth Beach, within the sought-after 33463 area. Enjoy the ease of having full-size washers and dryers in your spacious one-, two-, or three-bedroom home, enhanced with generous storage and select upgraded finishes.\n\nSet in a picturesque location by charming ponds, our community also offers diverse amenities such as a tennis court, pickleball court, and a car care station. With its appealing Outer Boynton Beach neighborhood, living at Savona Grand means enjoying modern comfort and easy access to all that Palm Beach County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments | Lake Worth Beach 33463",
      "seo_description": "Find in-unit laundry apartments in the 33463 area at Savona Grand. Enjoy the convenience of Lake Worth Beach living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-outer-boynton-beach-savona-grand",
      "search_query": "fitness center apartments Outer Boynton Beach",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Outer Boynton Beach",
      "h2_subtitle": "Savona Grand offers fitness center apartments in Outer Boynton Beach. Enjoy a healthy lifestyle in our modern community.",
      "page_copy": "Experience the vibrant lifestyle at Savona Grand, where fitness center apartments in Outer Boynton Beach are designed for both comfort and health-conscious living. Our community, located in the heart of Palm Beach County, caters to your fitness needs with modern facilities that complement our lovely pond-side setting. Choose from spacious one-, two-, or three-bedroom floor plans, each thoughtfully equipped with full-size washers and dryers and generous storage options.\n\nBeyond fitness, residents of Savona Grand have access to a range of amenities, including a tennis court, pickleball court, and a convenient car care station. The surrounding neighborhood offers a blend of peaceful residential living and easy access to local dining, shopping, and entertainment, providing a perfect balance for your active lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments | Outer Boynton Beach",
      "seo_description": "Discover fitness center apartments in Outer Boynton Beach at Savona Grand. Enjoy modern amenities and an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "gourmet-kitchen-apartments-lake-worth-beach-savona-grand",
      "search_query": "gourmet kitchen apartments Lake Worth Beach",
      "category": "Amenity",
      "h1_title": "Gourmet Kitchen Apartments in Lake Worth Beach",
      "h2_subtitle": "Explore gourmet kitchen apartments at Savona Grand in Lake Worth Beach. Enjoy stylish living in Palm Beach County.",
      "page_copy": "Discover the allure of Savona Grand, where gourmet kitchen apartments in Lake Worth Beach offer a perfect blend of style and functionality. Our one-, two-, and three-bedroom homes are designed with select upgraded finishes that inspire culinary creativity, set amidst the scenic beauty of Palm Beach County.\n\nIn addition to spacious living spaces, residents can enjoy an array of amenities like a tennis court, pickleball court, and a car care station. With a commitment to both elegance and convenience, our Outer Boynton Beach location ensures easy access to dining, shopping, and entertainment, making Savona Grand a premier choice for those seeking exceptional apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gourmet Kitchen Apartments | Lake Worth Beach",
      "seo_description": "Find gourmet kitchen apartments at Savona Grand in Lake Worth Beach. Enjoy stylish, spacious living in Palm Beach County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-lake-worth-beach-savona-grand",
      "search_query": "one bedroom apartments lake worth beach",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Lake Worth Beach",
      "h2_subtitle": "Explore one bedroom apartments at Savona Grand in Lake Worth Beach. Enjoy modern living in Palm Beach County.",
      "page_copy": "Discover the cozy elegance of our one bedroom apartments in Lake Worth Beach at Savona Grand. Nestled beside beautiful scenic ponds, our community offers the perfect blend of peaceful surroundings and modern amenities. Each apartment features full-size washers and dryers, generous storage options, and select upgraded finishes designed for comfortable living.\n\nSavona Grand's prime location in Outer Boynton Beach provides residents easy access to dining, shopping, and entertainment in Palm Beach County. Beyond stylish interiors, enjoy community amenities like a tennis court, pickleball court, and a convenient car care station. Whether you're seeking serenity or vibrant city life, our one bedroom apartments deliver the best of both worlds.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments | Lake Worth Beach",
      "seo_description": "Find one bedroom apartments at Savona Grand in Lake Worth Beach. Enjoy modern, comfortable living in a scenic Palm Beach County setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-palm-beach-county-savona-grand",
      "search_query": "two bedroom apartments palm beach county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Palm Beach County",
      "h2_subtitle": "Discover spacious two bedroom apartments at Savona Grand in Palm Beach County. Experience serene living with modern amenities.",
      "page_copy": "At Savona Grand, our two bedroom apartments in Palm Beach County provide the perfect balance of style and convenience. Situated in the tranquil setting of Outer Boynton Beach, our community offers scenic pond views and a variety of modern amenities that make everyday living a delight. Each apartment is equipped with full-size washers and dryers, generous storage space, and select upgraded finishes.\n\nEnjoy an active lifestyle with access to our tennis and pickleball courts or take advantage of the car care station. The community is ideally positioned to offer a peaceful retreat while remaining close to dining, shopping, and entertainment options throughout Palm Beach County. Choose Savona Grand for spacious, contemporary living tailored to your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments | Palm Beach County",
      "seo_description": "Find spacious two bedroom apartments at Savona Grand in Palm Beach County. Enjoy serene living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-outer-boynton-beach-savona-grand",
      "search_query": "three bedroom apartments near outer boynton beach",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Outer Boynton Beach",
      "h2_subtitle": "Explore spacious three bedroom apartments at Savona Grand, conveniently located near Outer Boynton Beach. Enjoy contemporary living spaces.",
      "page_copy": "At Savona Grand, we offer stunning three bedroom apartments near Outer Boynton Beach, providing ample space for families or those seeking extra room. Our thoughtfully designed floor plans boast full-size washers and dryers, generous storage solutions, and select upgraded finishes, all nestled in the picturesque setting of Palm Beach County.\n\nResidents can enjoy a wide range of amenities, including hardwood style plank flooring, tennis and pickleball courts perfect for sports enthusiasts, and a convenient car care station. The tranquil surroundings and close proximity to local dining and entertainment make living here the perfect choice for those looking for a blend of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Outer Boynton Beach",
      "seo_description": "Discover three bedroom apartments at Savona Grand near Outer Boynton Beach. Experience contemporary living with ample space and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "apartments-near-palm-beach-state-college-lake-worth-savona-grand",
      "search_query": "apartments near Palm Beach State College Lake Worth Beach",
      "category": "School",
      "h1_title": "Apartments Near Palm Beach State College",
      "h2_subtitle": "Discover convenient living with Savona Grand's apartments near Palm Beach State College in Lake Worth Beach. Enjoy modern amenities and a stylish design.",
      "page_copy": "Located just a short ride from Palm Beach State College, Savona Grand offers residents an ideal blend of convenience and style. Our apartments in Lake Worth Beach provide modern living spaces with floor plans that feature full-size washers and dryers, generous storage, and select upgraded finishes.\n\nPerfectly positioned in Palm Beach County's Outer Boynton Beach area, Savona Grand combines scenic pond views with practical amenities like a tennis court, pickleball court, and a car care station. Enjoy easy access to both academic pursuits and leisure activities, making our community a top choice for students and faculty alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Palm Beach State College",
      "seo_description": "Find apartments near Palm Beach State College at Savona Grand in Lake Worth Beach. Enjoy convenience and comfort with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "apartments-near-hca-florida-jfk-hospital-lake-worth-savona-grand",
      "search_query": "apartments near HCA Florida JFK Hospital Lake Worth",
      "category": "Hospital",
      "h1_title": "Apartments Near HCA Florida JFK Hospital",
      "h2_subtitle": "Live comfortably at Savona Grand, located near HCA Florida JFK Hospital in Lake Worth. Discover modern apartment living with premium amenities.",
      "page_copy": "Savona Grand offers the perfect location for those seeking apartments near HCA Florida JFK Hospital in Lake Worth. Our community provides convenient access to healthcare facilities while offering modern living spaces featuring spacious one-, two-, and three-bedroom floor plans with full-size washers and dryers, generous storage, and select upgraded finishes.\n\nSituated in the serene Outer Boynton Beach area, residents can enjoy tranquil pond views along with a host of amenities, including a tennis court, pickleball court, and car care station. Embrace a lifestyle of comfort and connectivity that's ideal for healthcare professionals and anyone appreciating quick access to medical services and a peaceful living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HCA Florida JFK Hospital",
      "seo_description": "Discover apartments near HCA Florida JFK Hospital at Savona Grand, Lake Worth. Enjoy modern amenities and convenient hospital access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "apartments-close-to-baptist-health-bethesda-hospital-east-savona-grand",
      "search_query": "apartments close to Baptist Health Bethesda Hospital East Palm Beach County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Baptist Health Bethesda",
      "h2_subtitle": "Explore modern apartments close to Baptist Health Bethesda Hospital East in Palm Beach County. Enjoy stylish living at Savona Grand.",
      "page_copy": "Nestled near the renowned Baptist Health Bethesda Hospital East, Savona Grand offers residents stylish apartments in Palm Beach County. Our community is conveniently located for easy access to one of the area's key healthcare facilities, making it an ideal choice for medical professionals and anyone seeking proximity to quality healthcare services.\n\nSavona Grand in Outer Boynton Beach features spacious one-, two-, and three-bedroom floor plans with full-size washers and dryers, ample storage, and select upgraded finishes. Engage in leisure activities with access to our tennis and pickleball courts, or tend to your vehicle at the car care station. The serene setting with scenic ponds creates an inviting atmosphere for residents seeking a balance of work and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Baptist Health Bethesda",
      "seo_description": "Find comfort and convenience at Savona Grand, close to Baptist Health Bethesda Hospital East in Palm Beach County. Perfect for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "apartments-near-lake-worth-beach-park-savona-grand",
      "search_query": "apartments near Lake Worth Beach Park FL",
      "category": "Park",
      "h1_title": "Apartments Near Lake Worth Beach Park",
      "h2_subtitle": "Discover Savona Grand, where luxury living meets convenience near Lake Worth Beach Park. Enjoy a vibrant coastal lifestyle.",
      "page_copy": "Positioned just a short distance from Lake Worth Beach Park, Savona Grand offers residents the ideal coastal living experience. Our beautiful apartments are designed to provide both comfort and convenience, with spacious floor plans that include full-size washers and dryers, generous storage, and select upgraded finishes.\n\nLocated in the scenic Outer Boynton Beach neighborhood of Palm Beach County, Savona Grand boasts amenities perfect for relaxation and recreation, such as a tennis court, pickleball court, and a car care station. Live the vibrant beach lifestyle with easy access to scenic beaches, while enjoying the tranquility of our scenic ponds and modern community features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lake Worth Beach Park",
      "seo_description": "Enjoy coastal living at Savona Grand, near Lake Worth Beach Park. Experience modern amenities and a vibrant lifestyle in Palm Beach County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "savona-grand-apartments-close-to-john-prince-park",
      "search_query": "Savona Grand apartments close to John Prince Park",
      "category": "Park",
      "h1_title": "Savona Grand Near John Prince Park",
      "h2_subtitle": "Experience the convenience of living at Savona Grand, just minutes from the expansive John Prince Park, offering plenty of outdoor activities.",
      "page_copy": "Savona Grand provides the ideal location for those who love outdoor adventures, being close to John Prince Park, a vast area known for its recreational facilities and scenic beauty. Our community in Lake Worth Beach perfectly balances modern living with nature's tranquility, offering spacious apartments that include full-size washers and dryers, ample storage, and classy finishes in select units.\n\nSet in the charming Outer Boynton Beach neighborhood of Palm Beach County, Savona Grand offers a host of amenities, including a tennis court, pickleball court, and a convenient car care station. Whether you're strolling through John Prince Park or enjoying the peaceful ambiance around our pristine ponds, Savona Grand is your gateway to a dynamic and comfortable lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Savona Grand Near John Prince Park",
      "seo_description": "Live near John Prince Park at Savona Grand. Enjoy spacious apartments and modern amenities, ideal for nature lovers and active lifestyles.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "apartments-near-ocean-inlet-park-savona-grand",
      "search_query": "apartments near Ocean Inlet Park Palm Beach County",
      "category": "Park",
      "h1_title": "Apartments Near Ocean Inlet Park",
      "h2_subtitle": "Find your perfect coastal home at Savona Grand, just a short drive from Ocean Inlet Park in Palm Beach County.",
      "page_copy": "Enjoy the coastal lifestyle with Savona Grand's prime location near Ocean Inlet Park in Palm Beach County. Our community offers residents the perfect blend of beachside living with modern comforts. Spacious one-, two-, and three-bedroom apartments come with full-size washers and dryers, generous storage, and some with stylish upgraded finishes, making it an excellent choice for beach enthusiasts.\n\nLocated in the serene Outer Boynton Beach neighborhood, Savona Grand delivers access to fantastic amenities, including a tennis and pickleball court, along with a car care station—all surrounded by scenic ponds. Whether you're heading out for a day at the beach or enjoying a quiet evening at home, Savona Grand is perfectly situated for both relaxation and adventure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ocean Inlet Park",
      "seo_description": "Discover beachside living at Savona Grand, near Ocean Inlet Park. Experience modern living and easy access to Palm Beach County's coastal beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167533",
      "source": "generator",
      "page_item_url": "savona-grand-close-to-ocean-front-beach-park",
      "search_query": "close to Ocean Front Beach Park Lake Worth Beach",
      "category": "Park",
      "h1_title": "Close to Ocean Front Beach Park",
      "h2_subtitle": "Live near the beautiful Ocean Front Beach Park at Savona Grand, where coastal charm meets elegant living in Lake Worth Beach.",
      "page_copy": "Nestled close to the stunning Ocean Front Beach Park, Savona Grand offers a premier living experience in Lake Worth Beach. Our spacious, well-appointed apartment homes feature full-size washers and dryers, ample storage, and select upgraded finishes, providing residents with all the comforts of modern living just minutes from the beach.\n\nLocated in the tranquil Outer Boynton Beach neighborhood, Savona Grand combines community amenities like a tennis court, pickleball court, and car care station with the beauty of surrounding scenic ponds. Experience the best of coastal living with easy access to the sun and sand, all while enjoying the serene and polished environment of our distinguished community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
      "featured_image_media": {
        "alt_text": "Lobby seating area with a view of the lake.",
        "public_id": "019eae0c-d453-730a-a669-5aafa234b2b9",
        "storage_key": "property/6767906449167533/019eae0c-d453-730a-a669-5aafa234b2b9.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close to Ocean Front Beach Park",
      "seo_description": "Enjoy elegant living at Savona Grand, near Ocean Front Beach Park. Experience both modern amenities and beach accessibility in Lake Worth Beach.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6382"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12232533682"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5680179"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T598GSHW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://savonagran.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "55519783467"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IndTYkFCclAxMFhIRnQ3ay84eWVQeHc9PSIsInZhbHVlIjoiQjhpeE9oNEU3R3d1c0xFYTVBU2VWZz09IiwibWFjIjoiZDFjMDA3Mjc0ZDhjZjFlZjJmMTcwMGVhNDAzZTkzMmNkMGQ2MDc2NjUwYWUxYWE3NDYzN2Q1OTk1YmQ5ODNkMSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "6382",
  "custom_repli_id": "12232533682",
  "custom_realpage_id": "5680179",
  "custom_google_gtm_id": "GTM-T598GSHW",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "none",
  "custom_betterbot_script": "<script src=\"https://savonagran.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "55519783467",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IndTYkFCclAxMFhIRnQ3ay84eWVQeHc9PSIsInZhbHVlIjoiQjhpeE9oNEU3R3d1c0xFYTVBU2VWZz09IiwibWFjIjoiZDFjMDA3Mjc0ZDhjZjFlZjJmMTcwMGVhNDAzZTkzMmNkMGQ2MDc2NjUwYWUxYWE3NDYzN2Q1OTk1YmQ5ODNkMSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "0c694ec9-7a5c-4d5b-a9a0-f828e7f8efb9",
  "custom_audioeye_site_hash": "d761f1d4194174bacd75f3516854c9ac"
};

export const generatedAt = '2026-11-03T20:22:29.743Z';
